import PageBreadcrumb from "../components/common/PageBreadCrumb";
import PageMeta from "../components/common/PageMeta";
import BillingTable from "../components/tables/BillingTable";
import InvoiceSettingsTable from "../components/billing/InvoiceSettingsTable";

export default function BillingPage() {
    return (
        <>
            <PageMeta
                title="Billing | Shoplattice Admin Dashboard"
                description="View billing details, credits, and invoice settings"
            />
            <PageBreadcrumb pageTitle="Billing" />
            <div className="space-y-6">
                <BillingTable />
                <InvoiceSettingsTable />
            </div>
        </>
    );
}
